import React, { useState } from 'react';
import P2PWalletTable from './P2PWalletTable';
import TransferModal from './TransferModal';

export default function P2PWalletPage() {
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [selectedWalletData, setSelectedWalletData] = useState(null);

  const handleTransferClick = (walletData) => {
    setSelectedWalletData(walletData);
    setOpenTransferModal(true);
  };

  return (
    <>
      <P2PWalletTable onTransferClick={handleTransferClick} />
      <TransferModal
        open={openTransferModal}
        onClose={() => setOpenTransferModal(false)}
        walletData={selectedWalletData}
      />
    </>
  );
}
